<template>
  <div class="tags-container">
    <span v-for="tag in tags" v-if="tag !== ''" :key="tag">{{ tag }}</span>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  props: {
    tags: {
      type: Array,
      required: true
    },
  },
}
</script>

<style scoped lang="scss">
.tags-container {
  display: flex;
  flex-wrap: wrap;
  span {
    background-color: #949494;
    display: inline;
    padding: 0.2em 0.6em 0.3em;
    margin: 0 1px 2px 0;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tags.vue